import { writable } from 'svelte/store'

export interface ImageResizeEvent {
  imagePath: string
  timestamp: number
}

export interface ImageDeleteEvent {
  imagePath: string
  timestamp: number
}

export const imageResizeEvents = writable<ImageResizeEvent | null>(null)
export const imageDeleteEvents = writable<ImageDeleteEvent | null>(null)

/**
 * Notify all components that an image has been resized
 */
export function notifyImageResized(imagePath: string): void {
  imageResizeEvents.set({
    imagePath,
    timestamp: Date.now()
  })
}

/**
 * Notify all components that an image has been deleted
 */
export function notifyImageDeleted(imagePath: string): void {
  imageDeleteEvents.set({
    imagePath,
    timestamp: Date.now()
  })
}
